import { Route } from 'types/route.type';
import CreateFeedStrategies from './components/create-feed-strategies';
import EditFeedStrategies from './components/edit-feed-strategies';
import ListFeedStrategies from './list-feed-strategies';

export const routes: Route[] = [
  {
    path: '/profiles-strategies/feed-strategies',
    component: ListFeedStrategies,
    id: 'features.profilesStrategies',
  },
  {
    path: '/profiles-strategies/feed-strategies/create',
    component: CreateFeedStrategies,
    id: 'profilesStrategies.createFeedStrategies.title',
  },
  {
    path: '/profiles-strategies/feed-strategies/:id',
    component: EditFeedStrategies,
  },
];
